import React, { useEffect } from "react";
import { Box, height } from "@mui/system";
import useMakeScrollable from "custom_hooks/make-scrollable";
import { Link, Typography, Button } from "@mui/material";
import BackIcon from "@mui/icons-material/ArrowBack";
import { makeStyles } from "@mui/styles";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useHistory } from "react-router-dom";
import { SurveyHeroIcon } from "./SurveyHeroIcon";
import { SurveyButton } from "./SurveyButton";

const styles: any = (theme) => ({
  root: {
    color: "#fff",
    background: "linear-gradient(to top,#7CD1EA 0%, #4397E6 100%)",
    minHeight: "100vh",
    opacity: 1,
    marginTop: '-60px',
  },
  backIcon: {
    zIndex: 200,
    position: "absolute",
    left: 24,
    top: 120,
    color: "#fff",
  },
  points: {
    backgroundColor: "#E6F7FF",
    borderRadius: 15,
    width: "100%",
    marginTop: "33px",
    padding: "8px 4px",
  },
});

const useStyles = makeStyles(styles);

export function SurveyDetailOnboarding({ survey, begin }) {
  const classes = useStyles();

  useMakeScrollable();
  const history = useHistory();
  const routeToSurveys = () => history.push("/surveys-list");

  return (
    <div className="scrollable">
      <Box className={classes.root}>
        <Box sx={{ width: "80%", margin: "50px auto" }}>
          <Link href="/#/surveys-list">
            <BackIcon className={classes.backIcon} />
          </Link>
          <Box
            paddingTop={"99px"}
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <SurveyHeroIcon />
          </Box>
          <Box display="flex" flexDirection={"column"} justifyContent="center">
            <Typography
              marginTop="27px"
              align="center"
              fontSize={30}
              fontWeight="light"
              fontFamily="Montserrat"
              color="inherit"
            >
              Umfrage
            </Typography>
            <Typography
              marginTop={2}
              align="center"
              fontSize={18}
              lineHeight={"25px"}
              fontWeight="bold"
              fontFamily="Montserrat"
              color="inherit"
            >
              {survey?.name || ''}
            </Typography>
            <Box
              className={classes.points}
              display="flex"
              flexDirection="column"
              alignItems={"center"}
            >
              <Typography fontWeight={"bold"} fontSize="22px" color="#238CB9">
                {survey?.credits ?? 0}
              </Typography>
              <Typography
                align="center"
                width="50%"
                fontSize={11}
                fontWeight="900"
                color="#8CBCDB"
              >
                PUNKTE FÜR DURCHFÜHRUNG
              </Typography>
            </Box>
            <Box marginTop={"33px"} marginBottom={"30px"}>
              <Typography fontSize={14} align="left" lineHeight={"22px"}>
                {survey?.description}
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection={"column"}
              alignItems={"center"}
              justifyContent="center"
              marginTop={"30px"}
              marginBottom={"40px"}
            >
              <SurveyButton
                endIcon={<ArrowForward />}
                sx={{ padding: "18px 12px", color: "#238CB9" }}
                onClick={begin}
              >
                <Typography
                  textTransform={"uppercase"}
                  fontWeight={"bold"}
                  fontSize={16}
                  color="#238CB9"
                >
                  UMFRAGE STARTEN
                </Typography>
              </SurveyButton>
              <Box marginTop={"17px"}>
                <Button onClick={routeToSurveys}>
                  <Typography
                    color="#fff"
                    fontSize={"16px"}
                    fontWeight={"bold"}
                  >
                    Abbrechen
                  </Typography>
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
